import { api, defaultQueriesFor } from '../apiSlice';

export const blogPostApi = api
  .enhanceEndpoints({ addTagTypes: ['BlogPost'] })
  .injectEndpoints({
    endpoints: build => ({
      ...defaultQueriesFor(build, 'BlogPost', 'BlogPosts'),
    }),
  });

export const {
  useCreateBlogPostMutation,
  useDeleteBlogPostMutation,
  useGetBlogPostByIdQuery,
  useGetBlogPostsQuery,
  useUpdateBlogPostMutation,
} = blogPostApi;
